import React, { useState } from "react";

// import JS files
import PanelTemplate from "../../../shares/PanelTemplate";
import TabOne from "./TabOne";
import TabTwo from "./TabTwo";

const ProviderCurrentOrders = (props) => {
  const [activeTab, setActiveTab] = useState("1");

  return (
    <>
      <PanelTemplate sidebarActiveLink="c-current-orders">
        <>
          <div className="panel-main-header">
            <span>سفارش‌های جاری</span>
          </div>
          <div className="mt-8 flex items-center">
            <span
              className={activeTab == "1" ? "active-tab" : "not-active-tab"}
              onClick={() => setActiveTab("1")}
            >
              براساس مشتری
            </span>
            <span
              className={activeTab == "2" ? "active-tab" : "not-active-tab"}
              onClick={() => setActiveTab("2")}
            >
              براساس النگو
            </span>
          </div>
          <div
            style={{ backgroundColor: "#fefcfb" }}
            className="border rounded-b-md rounded-tl-md px-2 py-6 mb-4"
          >
            {activeTab == "1" ? <TabOne /> : <TabTwo />}
          </div>
        </>
      </PanelTemplate>
    </>
  );
};

export default ProviderCurrentOrders;
